import { render, staticRenderFns } from "./NavigatorBottomBarButtonMetrics.vue?vue&type=template&id=1d595e74"
import script from "./NavigatorBottomBarButtonMetrics.vue?vue&type=script&lang=js"
export * from "./NavigatorBottomBarButtonMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports